import { api } from 'services/api';

const basketService = api
  .enhanceEndpoints({
    addTagTypes: ['BasketItems'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      basketItems: builder.query<ResultModel<BasketItemsResponse>, BasketItemsRequest>({
      query: (body) => ({
        url: `/563371BA3ACC37/BasketItems`,
        method: 'POST',
        body,
      }),
      providesTags: [{ type: 'BasketItems', id: 'LIST' }],
      extraOptions: { isProfile: true },
    }),
    basketSummary: builder.query<ResultModel<BasketSummaryResponse>, BasketSummaryRequest>({
      query: (body) => ({
        url: `/563371BA3ACC37/BasketSummary`,
        method: 'POST',
        body,
      }),
      extraOptions: { isProfile: true },
    }),
    validateCoupon: builder.mutation<
      ResultModel<ValidatePromoCodeResponse>,
      ValidatePromoCodeRequest
    >({
      query: (body) => ({
        url: `/563371BA3ACC37/ValidatePromoCode`,
        method: 'POST',
        body,
      }),
      extraOptions: { isProfile: true },
    }),
    rollbackPromoCodes: builder.mutation<
      ResultModel<void>,
      RollbackPromoCodesRequest
    >({
      query: (body) => ({
        url: `/563371BA3ACC37/RollbackPromoCodes`,
        method: 'POST',
        body,
      }),
      extraOptions: { isProfile: true },
    }),
  }),
});

export const { useBasketItemsQuery, useBasketSummaryQuery, useValidateCouponMutation, useRollbackPromoCodesMutation } =
  basketService;
